// v86 guest networking helpers. v86 picks its Wisp adapter from a wisp:// or wisps:// relay URL;
// everywhere else (settings, defaults) the endpoint stays an ordinary ws(s):// URL.
// Ported from EndisOS src/linux/v86/network.ts.
import { LinuxError } from "../engine.js";

export function wispRelay(input, secure = false) {
	if (!input || !String(input).trim()) return undefined;
	let url;
	try { url = new URL(String(input).trim()); } catch (e) { throw new LinuxError("PROCESS_FAILED", "The Wisp endpoint isn't a valid URL."); }
	if ((url.protocol !== "ws:" && url.protocol !== "wss:") || url.username || url.password || url.hash) throw new LinuxError("PROCESS_FAILED", "Use a ws:// or wss:// Wisp endpoint without credentials or a #fragment.");
	if (secure && url.protocol !== "wss:") throw new LinuxError("PROCESS_FAILED", "Re:Vault is served over HTTPS, so the Wisp endpoint must be a secure wss:// URL.");
	return url.href.replace(/^ws/, "wisp");
}

// Re:Vault's own Linux relay on this origin (opaque path from the build manifest).
export function defaultWispUrl(prefix, loc) {
	if (!prefix) return "";
	return (loc.protocol === "https:" ? "wss://" : "ws://") + loc.host + prefix;
}

// v86 resolves guest DNS itself with DNS-over-HTTPS: fetch("https://" + doh_server + "/dns-query").
// It can only be given a host name, so it's given a reserved .invalid name and this shim sends that
// one exact URL to Re:Vault's same-origin resolver instead (which applies Re:Vault's DNS policy and
// isn't blocked like cloudflare-dns.com often is on school networks). Nothing else is touched.
export const DOH_SENTINEL = "revault-dns.invalid";
export const DOH_SENTINEL_URL = "https://" + DOH_SENTINEL + "/dns-query";
export function installDohShim(target, g = globalThis) {
	if (g.__rvDohShim) { g.__rvDohShim.target = target; return g.__rvDohShim; }
	const orig = g.fetch.bind(g);
	const shim = { target, orig };
	g.fetch = (input, init) => {
		const url = typeof input === "string" ? input : input instanceof URL ? input.href : input && input.url;
		if (url === DOH_SENTINEL_URL && shim.target) return orig(shim.target, init);
		return orig(input, init);
	};
	g.__rvDohShim = shim;
	return shim;
}
